<template>
  <div class="fixed top-0 h-20 bg-white w-full z-50 shadow-sm flex items-center px-8">
    <div class="absolute border font-bold top-24 min-w-[160px] left-4  rounded px-4 py-2 z-50"
         :class="{
          'hidden': !flashMessage && !flashError,
          'border-jt-blue text-jt-blue bg-jt-light-blue': flashMessage,
          'border-jt-red text-jt-red bg-jt-light-red': flashError
         }"
         v-if="flashError">
      <span class="text-sm">{{ flashMessage || flashError }}</span>
    </div>
    <a :href="backUrl" v-if="activeProfileName" class="text-xl">
      {{ activeProfileName }}
    </a>
    <div class="ml-auto flex items-center gap-4">
      <div class="flex items-center gap-2 relative">
        <div @click="localOpen = !localOpen" class="border bg-white w-[38px] text-sm justify-center rounded-full px-2 py-2 text-center font-semibold flex items-center gap-2 cursor-pointer">
          {{ localLabel }}
        </div>
        <div v-if="localOpen" class="">
          <div class="fixed w-screen h-screen top-0 left-0  z-50">
            <div class="w-full h-full bg-black opacity-50" @click="localOpen = false"></div>
            <div class="absolute top-[200px] left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-8 rounded-lg flex flex-col gap-4">
              <div class="flex items-center justify-between mb-6">
                <h2 class="text-2xl font-bold">{{ i18n.t('marketplace.general.language') }}</h2>
                <i class="bi bi-x-lg cursor-pointer text-xl" @click="localOpen = false"></i>
              </div>
              <div class="grid lg:grid-cols-3 gap-4">
                <div v-for="lang in languages" :key="lang.code" 
                  @click="setLocale(lang.code); locale = lang.code"
                  class="flex gap-2 py-3 px-4 border-2 border-solid cursor-pointer bg-gray-100 rounded-lg text-sm" 
                  :class="{
                    '!border-black': locale === lang.code,
                    '!border-transparent': locale !== lang.code
                  }"
                >
                  <img :src="`/images/marketplace/languages/${lang.code}.svg`" class="w-6 h-4 object-cover mt-1"/>
                  <div>
                    <div class="font-bold">{{ lang.name }}</div>
                    <div class="text-sm text-gray-500">{{ lang.country }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Cart
        :cart="cart"
        :cartItems="cartItems"
        :timeSeconds="timeSeconds"
        @clearCart="cardReset"
        @update-cart="updateCart"
      />
    </div>
  </div>
</template>

<script>
  import Cart from './top_navigation/cart.vue'
  import axios from '../shared/custom_axios.js';

  export default {
    name: 'TopNavigation',
    props: {
      cartNumber: String,
      cartUrl: String,
      backUrl: String,
      updateCartUrl: String,
      flashMessage: String,
      flashError: String,
      profileName: String,
      timeSeconds: {
        type: String,
        default: '1800'
      }
    },
    data: function() {
      return {
        activeProfileName: localStorage.getItem('profileName'),
        cart: null,
        localOpen: false,
        cartItems: [],
        locale: localStorage.getItem('locale') || document.body.dataset.lang,
        languages: [
          { code: 'cs', name: 'Čeština', country: 'Czechia' },
          { code: 'de', name: 'Deutsch', country: 'Deutschland' },
          { code: 'en', name: 'English', country: 'United States' },
          { code: 'es', name: 'Español', country: 'España' },
          { code: 'fr', name: 'Français', country: 'France' },
          { code: 'it', name: 'Italiano', country: 'Italia' },
        ]
      }
    },
    created: function() {
      this.fetchCart();
      if (this.profileName.length > 0) {
        window.activeProfileName = this.profileName;
      }
      this.activeProfileName = window.activeProfileName;
    },
    watch: {
      cart() {
        window.activeCart = this.cart;
      }
    },
    computed: {
      localLabel() {
        if (this.locale == 'en') return 'EN';
        if (this.locale == 'cs') return 'CS';
        if (this.locale == 'it') return 'IT';
        if (this.locale == 'es') return 'ES';
        if (this.locale == 'de') return 'DE';
        if (this.locale == 'fr') return 'FR';
      }
    },
    components: {
      Cart
    },
    methods: {
      fetchCart: function() {
        let cartNumber = this.cartNumber || localStorage.getItem('cartNumber');

        if (!cartNumber) {
          cartNumber = localStorage.getItem('cartNumber');
        }

        if (cartNumber) {
          fetch(this.cartUrl + '?cart_id=' + cartNumber)
            .then(response => response.json())
            .then(data => {
              this.cart = data.data;
              this.cartItems = data.included || [];
              localStorage.setItem('cartNumber', this.cart.attributes.number);
              this.cardRemove();
            });
        }
      },
      updateCart: function(itemId, quantity, booking) {
        let cartId = null;
        if (this.cart) {
          cartId = this.cart.attributes.number;
        }
        axios.patch(this.updateCartUrl, {
          cart_id: cartId,
          item_id: itemId,
          quantity: quantity,
          booking: booking
        })
          .then(response => {
            this.cart = response.data.data;
            this.cartItems = response.data.included || [];
            if (quantity > 0) {
              topNavigation.addMessage(this.i18n.t('cart.product_added'));
            } else {
              topNavigation.addMessage(this.i18n.t('cart.product_removed'));
            }
            localStorage.setItem('cartNumber', this.cart.attributes.number);
            this.cardRemove(); 
          })
          .catch(error => {
            this.cardRemove();
            topNavigation.addMessage(error.response.data.error, 'error');
          });
      },
      cardReset() {
        localStorage.removeItem('cartNumber');
        this.cart = null;
        this.cartItems = [];
        topNavigation.cartNumber = null;
      },
      cardRemove() {
        if (!this.cart?.attributes?.expired && this.cartItems.length > 0) return;

        if (this.cart?.attributes?.expired) {
          topNavigation.addMessage(this.i18n.t('cart.cart_expired'), 'error');
        }
        this.cardReset();
      },
      setLocale(locale) {
        localStorage.setItem('locale', locale);
        let url = window.location.pathname.split('/');
        url[1] = locale;
        window.location.href = url.join('/') + window.location.search;
      }
    }
  }
</script>
